import React from 'react';

import PropTypes from 'prop-types';

import './KeyValueDataComponent.css';

import {
  FormFieldLabel,
  Paragraph
} from '../../../StyledComponents';

const KeyValueDataComponent = (props) => {
  const newData = [];
  for (let key in props.data) {
    if (
      key === 'dobyyyy' ||
      key === 'dobmm' ||
      key ==='dobdd' ||
      key === 'timeSpentAtCurrentEmployeryy' ||
      key === 'timeSpentAtCurrentEmployermm' ||
      key === 'timeSpentAtPreviousEmployeryy' ||
      key === 'timeSpentAtPreviousEmployermm' ||
      key === 'bankAccountYearsOpen' ||
      key === 'bankAccountMonthsOpen'
    ){
      continue;
    }
    newData.push({
      label: props.data[key].label,
      value: props.data[key].value
    });
  }

  return(
    <div className="key-value-data-wrapper">
      {
        props.data ?
          newData.map(item => {
            return(
              <React.Fragment key={item.label}>
                {
                  (item.label !== 'Search Address') ?
                    <div className="key-value-data-row" key={item.label}>
                      <div className="key-label">
                        <FormFieldLabel
                          automationidattr={item.label}
                        >{item.label}:</FormFieldLabel>
                      </div>
                      <div className="value-label">
                        <Paragraph
                          automationidattr={item.value}
                        >{item.value ? item.value : '-'}</Paragraph>
                      </div>
                    </div>
                    :
                    null
                }
              </React.Fragment>
            );
          })
          :
          null
      }
    </div>
  );
};

KeyValueDataComponent.propTypes = {
  data: PropTypes.object
};

export default KeyValueDataComponent;